import { SCHEDULING_MINUTE_STEP } from "../time-granularity"

export type TimeSlot = {
  label: string
  ariaLabel: string
  showLabel: boolean
  value: number
}

export const startOfDay = (date: Date) => {
  const copy = new Date(date)
  copy.setHours(0, 0, 0, 0)

  return copy
}

export const setTime = (date: Date, hours: number, minutes: number) => {
  const copy = new Date(date)
  copy.setHours(hours, minutes, 0, 0)

  return copy
}

export const startOfWeek = (date: Date) => {
  const copy = startOfDay(date)
  const weekday = copy.getDay()
  const diff = weekday === 0 ? -6 : 1 - weekday
  copy.setDate(copy.getDate() + diff)

  return copy
}

export const addDays = (date: Date, days: number) => {
  const copy = new Date(date)
  copy.setDate(copy.getDate() + days)

  return copy
}

export const addMinutes = (date: Date, minutes: number) => {
  const copy = new Date(date)
  copy.setMinutes(copy.getMinutes() + minutes)

  return copy
}

export const buildTimeSlots = (
  startHour: number,
  endHour: number,
  stepMinutes: number = SCHEDULING_MINUTE_STEP,
): TimeSlot[] => {
  const slots: TimeSlot[] = []
  const startMinutes = startHour * 60
  const endMinutes = endHour * 60
  for (let minutes = startMinutes; minutes <= endMinutes; minutes += stepMinutes) {
    const fullLabel = formatTime(setTime(new Date(), Math.floor(minutes / 60), minutes % 60))
    const showLabel = minutes % 15 === 0
    slots.push({
      label: showLabel ? fullLabel : "",
      ariaLabel: fullLabel,
      showLabel,
      value: minutes,
    })
  }

  return slots
}

export const formatWeekRange = (start: Date, end: Date) => {
  const sameYear = start.getFullYear() === end.getFullYear()
  const startLabel = start.toLocaleDateString("de-DE", {
    day: "numeric",
    month: "short",
    year: sameYear ? undefined : "numeric",
  })
  const endLabel = end.toLocaleDateString("de-DE", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })

  return `${startLabel} – ${endLabel}`
}

export const formatTime = (value: Date) =>
  value.toLocaleTimeString("de-DE", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })

export const formatDayHeader = (day: Date) =>
  day.toLocaleDateString("de-DE", { weekday: "long", day: "numeric", month: "short" })
